import React from "react";
import styles from "./HallsItemSkeleton.module.scss";

export const HallsItemSkeleton: React.FC = () => {
  return (
    <div className={styles.item}>
      <div className={styles.img}>
        <div className={styles.skeletonImage} />
      </div>
      <div className={styles.title}>
        <div className={styles.skeletonTitle} />
      </div>
      <div className={styles.buttons}>
        <div className={styles.skeletonButton} />
        <div className={styles.skeletonButton} />
      </div>
    </div>
  );
};

export default HallsItemSkeleton;

